import * as React from "react"
import { SVGProps } from "react"

import styles from "./../styles.module.scss"
import classNames from "classnames"

const PhoneIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 554 194"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={styles.animatedCourier}
	>
		<g className={styles.animatedCourier__tree}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M75.6572 191.969H32.399C32.1412 191.292 32 190.557 32 189.789C32 186.405 34.7434 183.662 38.1275 183.662C38.6099 183.662 39.0792 183.717 39.5294 183.823C40.3277 178.58 44.8551 174.563 50.3207 174.563C55.3891 174.563 59.6508 178.018 60.88 182.7C62.4689 181.388 64.5063 180.6 66.728 180.6C71.803 180.6 75.9172 184.714 75.9172 189.789C75.9172 190.54 75.8271 191.27 75.6572 191.969Z"
				fill="#F5F5F5"
			/>
			<path
				d="M32.399 191.969L30.9971 192.502C31.2186 193.084 31.7764 193.469 32.399 193.469V191.969ZM75.6572 191.969V193.469C76.349 193.469 76.9511 192.996 77.1146 192.323L75.6572 191.969ZM39.5294 183.823L39.1876 185.283C39.5949 185.379 40.0235 185.3 40.37 185.065C40.7165 184.831 40.9493 184.462 41.0123 184.049L39.5294 183.823ZM60.88 182.7L59.4292 183.081C59.5591 183.576 59.9326 183.971 60.4198 184.128C60.9069 184.285 61.4406 184.183 61.8352 183.857L60.88 182.7ZM32.399 193.469H75.6572V190.469H32.399V193.469ZM33.8008 191.435C33.6069 190.926 33.5 190.372 33.5 189.789H30.5C30.5 190.742 30.6754 191.657 30.9971 192.502L33.8008 191.435ZM33.5 189.789C33.5 187.234 35.5718 185.162 38.1275 185.162V182.162C33.915 182.162 30.5 185.577 30.5 189.789H33.5ZM38.1275 185.162C38.4939 185.162 38.8486 185.204 39.1876 185.283L39.8712 182.362C39.3098 182.231 38.7258 182.162 38.1275 182.162V185.162ZM41.0123 184.049C41.7007 179.528 45.6075 176.063 50.3207 176.063V173.063C44.1027 173.063 38.9547 177.633 38.0465 183.597L41.0123 184.049ZM50.3207 176.063C54.6906 176.063 58.3687 179.042 59.4292 183.081L62.3309 182.32C60.9328 176.994 56.0877 173.063 50.3207 173.063V176.063ZM61.8352 183.857C63.1652 182.758 64.8676 182.1 66.728 182.1V179.1C64.145 179.1 61.7725 180.018 59.9248 181.544L61.8352 183.857ZM66.728 182.1C70.9746 182.1 74.4172 185.542 74.4172 189.789H77.4172C77.4172 183.885 72.6315 179.1 66.728 179.1V182.1ZM74.4172 189.789C74.4172 190.42 74.3416 191.031 74.1997 191.614L77.1146 192.323C77.3126 191.509 77.4172 190.66 77.4172 189.789H74.4172Z"
				fill="#2A2D33"
			/>
			<path
				d="M71.2305 163.08H80.6042L81.4402 191.969H70.3945L71.2305 163.08Z"
				fill="#F7F7F7"
				stroke="#2A2D33"
				strokeWidth="3"
			/>
			<circle
				cx="75.9174"
				cy="140.874"
				r="26.9057"
				fill="#F7F7F7"
				stroke="#2A2D33"
				strokeWidth="3"
			/>
		</g>
		<g
			className={classNames(
				styles.animatedCourier__tree,
				styles.animatedCourier__treeSecond
			)}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M75.6572 191.969H32.399C32.1412 191.292 32 190.557 32 189.789C32 186.405 34.7434 183.662 38.1275 183.662C38.6099 183.662 39.0792 183.717 39.5294 183.823C40.3277 178.58 44.8551 174.563 50.3207 174.563C55.3891 174.563 59.6508 178.018 60.88 182.7C62.4689 181.388 64.5063 180.6 66.728 180.6C71.803 180.6 75.9172 184.714 75.9172 189.789C75.9172 190.54 75.8271 191.27 75.6572 191.969Z"
				fill="#F5F5F5"
			/>
			<path
				d="M32.399 191.969L30.9971 192.502C31.2186 193.084 31.7764 193.469 32.399 193.469V191.969ZM75.6572 191.969V193.469C76.349 193.469 76.9511 192.996 77.1146 192.323L75.6572 191.969ZM39.5294 183.823L39.1876 185.283C39.5949 185.379 40.0235 185.3 40.37 185.065C40.7165 184.831 40.9493 184.462 41.0123 184.049L39.5294 183.823ZM60.88 182.7L59.4292 183.081C59.5591 183.576 59.9326 183.971 60.4198 184.128C60.9069 184.285 61.4406 184.183 61.8352 183.857L60.88 182.7ZM32.399 193.469H75.6572V190.469H32.399V193.469ZM33.8008 191.435C33.6069 190.926 33.5 190.372 33.5 189.789H30.5C30.5 190.742 30.6754 191.657 30.9971 192.502L33.8008 191.435ZM33.5 189.789C33.5 187.234 35.5718 185.162 38.1275 185.162V182.162C33.915 182.162 30.5 185.577 30.5 189.789H33.5ZM38.1275 185.162C38.4939 185.162 38.8486 185.204 39.1876 185.283L39.8712 182.362C39.3098 182.231 38.7258 182.162 38.1275 182.162V185.162ZM41.0123 184.049C41.7007 179.528 45.6075 176.063 50.3207 176.063V173.063C44.1027 173.063 38.9547 177.633 38.0465 183.597L41.0123 184.049ZM50.3207 176.063C54.6906 176.063 58.3687 179.042 59.4292 183.081L62.3309 182.32C60.9328 176.994 56.0877 173.063 50.3207 173.063V176.063ZM61.8352 183.857C63.1652 182.758 64.8676 182.1 66.728 182.1V179.1C64.145 179.1 61.7725 180.018 59.9248 181.544L61.8352 183.857ZM66.728 182.1C70.9746 182.1 74.4172 185.542 74.4172 189.789H77.4172C77.4172 183.885 72.6315 179.1 66.728 179.1V182.1ZM74.4172 189.789C74.4172 190.42 74.3416 191.031 74.1997 191.614L77.1146 192.323C77.3126 191.509 77.4172 190.66 77.4172 189.789H74.4172Z"
				fill="#2A2D33"
			/>
			<path
				d="M71.2305 163.08H80.6042L81.4402 191.969H70.3945L71.2305 163.08Z"
				fill="#F7F7F7"
				stroke="#2A2D33"
				strokeWidth="3"
			/>
			<circle
				cx="75.9174"
				cy="140.874"
				r="26.9057"
				fill="#F7F7F7"
				stroke="#2A2D33"
				strokeWidth="3"
			/>
		</g>

		<g className={styles.animatedCourier__wheel}>
			<circle
				cx="358.914"
				cy="167.918"
				r="24.0006"
				fill="#F5F5F5"
				stroke="#2A2D33"
				strokeWidth="3"
				strokeLinejoin="round"
			/>
			<circle
				cx="358.913"
				cy="167.918"
				r="11.1765"
				fill="#F5F5F5"
				stroke="#2A2D33"
				strokeWidth="3"
				strokeLinejoin="round"
			/>
		</g>

		<g className={styles.animatedCourier__wheel}>
			<circle
				cx="220.474"
				cy="167.918"
				r="24.0006"
				fill="#F5F5F5"
				stroke="#2A2D33"
				strokeWidth="3"
				strokeLinejoin="round"
			/>
			<circle
				cx="220.474"
				cy="167.918"
				r="11.1765"
				fill="#F5F5F5"
				stroke="#2A2D33"
				strokeWidth="3"
				strokeLinejoin="round"
			/>
		</g>

		<g className={styles.animatedCourier__courier}>
			<path
				d="M240.156 89.9239C238.09 82.2102 238.432 74.1103 241.125 67.0219C243.817 59.9336 248.691 54.3015 254.905 51.0975C261.119 47.8936 268.283 47.3188 275.162 49.4723C282.04 51.6259 288.201 56.3727 292.581 62.8936L268.991 82.1978L240.156 89.9239Z"
				fill="#F5F5F5"
				stroke="#2A2D33"
				strokeWidth="3"
			/>
			<path
				d="M358.901 167.917H326.606C321.773 167.917 317.765 164.175 317.434 159.353L311.62 74.5894C311.256 69.2767 315.467 64.7666 320.793 64.7666H321.024L358.901 167.917Z"
				fill="#F5F5F5"
				stroke="#2A2D33"
				strokeWidth="3"
				strokeLinejoin="round"
			/>
			<path
				d="M322.503 89.7793C322.503 85.1634 326.245 81.4214 330.861 81.4214H339.219V98.1373H330.861C326.245 98.1373 322.503 94.3953 322.503 89.7793Z"
				fill="#F5F5F5"
				stroke="#2A2D33"
				strokeWidth="3"
				strokeLinejoin="round"
			/>
			<rect
				x="189.719"
				y="113.087"
				width="90.3215"
				height="13.9055"
				rx="6.95274"
				fill="#F5F5F5"
				stroke="#2A2D33"
				strokeWidth="3"
				strokeLinejoin="round"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M259.891 139.304C259.891 133.192 264.265 128.101 270.054 126.992H233.847V167.917H251.097V167.917H328.29V161.231H272.414C265.496 161.224 259.891 155.613 259.891 148.694V139.304Z"
				fill="#F5F5F5"
			/>
			<path
				d="M270.054 126.992L270.336 128.465C271.096 128.319 271.62 127.62 271.547 126.85C271.474 126.08 270.827 125.492 270.054 125.492V126.992ZM233.847 126.992V125.492C233.018 125.492 232.347 126.163 232.347 126.992H233.847ZM233.847 167.917H232.347C232.347 168.745 233.018 169.417 233.847 169.417V167.917ZM251.097 167.917H252.597C252.597 167.088 251.926 166.417 251.097 166.417V167.917ZM251.097 167.917H249.597C249.597 168.746 250.269 169.417 251.097 169.417V167.917ZM328.29 167.917V169.417C329.119 169.417 329.79 168.746 329.79 167.917H328.29ZM328.29 161.231H329.79C329.79 160.403 329.119 159.731 328.29 159.731V161.231ZM272.414 161.231L272.412 162.731H272.414V161.231ZM269.771 125.519C263.289 126.761 258.391 132.459 258.391 139.304H261.391C261.391 133.925 265.241 129.441 270.336 128.465L269.771 125.519ZM233.847 128.492H270.054V125.492H233.847V128.492ZM235.347 167.917V126.992H232.347V167.917H235.347ZM251.097 166.417H233.847V169.417H251.097V166.417ZM252.597 167.917V167.917H249.597V167.917H252.597ZM328.29 166.417H251.097V169.417H328.29V166.417ZM326.79 161.231V167.917H329.79V161.231H326.79ZM272.414 162.731H328.29V159.731H272.414V162.731ZM258.391 148.694C258.391 156.441 264.667 162.723 272.412 162.731L272.415 159.731C266.325 159.724 261.391 154.786 261.391 148.694H258.391ZM258.391 139.304V148.694H261.391V139.304H258.391Z"
				fill="#2A2D33"
			/>

			<path
				d="M261.4 167.918C261.4 157.063 257.088 146.654 249.413 138.979C241.738 131.304 231.328 126.992 220.474 126.992C209.62 126.992 199.211 131.304 191.536 138.979C183.861 146.654 179.549 157.063 179.549 167.918L261.4 167.918Z"
				fill="#F5F5F5"
				stroke="#2A2D33"
				strokeWidth="3"
				strokeLinejoin="round"
			/>

			<path
				d="M317.988 167.918C317.988 159.823 320.389 151.911 324.885 145.181C329.382 138.451 335.774 133.205 343.252 130.107C350.73 127.01 358.959 126.199 366.898 127.779C374.837 129.358 382.129 133.255 387.852 138.979L358.914 167.918H317.988Z"
				fill="#F5F5F5"
				stroke="#2A2D33"
				strokeWidth="3"
				strokeLinejoin="round"
			/>
			<rect
				x="169.954"
				y="44.4209"
				width="68.6656"
				height="68.6656"
				rx="2.50738"
				fill="#F5F5F5"
				stroke="#2A2D33"
				strokeWidth="3"
			/>
			<path
				d="M166.147 46.9283C166.147 45.5435 167.27 44.4209 168.655 44.4209H236.112C237.497 44.4209 238.619 45.5435 238.619 46.9283V65.8203H168.655C167.27 65.8203 166.147 64.6977 166.147 63.3129V46.9283Z"
				fill="#F5F5F5"
				stroke="#2A2D33"
				strokeWidth="3"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M200.943 95.5352H169.954V102.222H200.943L200.943 113.087H207.629V102.222H238.619V95.5352H207.629H200.943Z"
				fill="#F5F5F5"
			/>
			<path
				d="M169.954 95.5352V94.0352H168.454V95.5352H169.954ZM169.954 102.222H168.454V103.722H169.954V102.222ZM200.943 102.222L202.443 102.222L202.443 100.722H200.943V102.222ZM200.943 113.087H199.443V114.587H200.943V113.087ZM207.629 113.087V114.587H209.129V113.087H207.629ZM207.629 102.222V100.722H206.129V102.222H207.629ZM238.619 102.222V103.722H240.119V102.222H238.619ZM238.619 95.5352H240.119V94.0352H238.619V95.5352ZM169.954 97.0352H200.943V94.0352H169.954V97.0352ZM171.454 102.222V95.5352H168.454V102.222H171.454ZM200.943 100.722H169.954V103.722H200.943V100.722ZM202.443 113.087V102.222L199.443 102.222L199.443 113.087H202.443ZM207.629 111.587H200.943V114.587H207.629V111.587ZM206.129 102.222V113.087H209.129V102.222H206.129ZM238.619 100.722H207.629V103.722H238.619V100.722ZM237.119 95.5352V102.222H240.119V95.5352H237.119ZM207.629 97.0352H238.619V94.0352H207.629V97.0352ZM200.943 97.0352H207.629V94.0352H200.943V97.0352Z"
				fill="#2A2D33"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M303.459 75.5122C300.944 74.5346 298.108 74.3196 295.303 75.0713L239.335 90.0678L242.559 102.099C244.536 109.479 252.122 113.858 259.501 111.881L278.699 106.737L269.995 132.511L294.902 140.922L311.401 92.0642C313.69 85.2887 310.14 77.9498 303.459 75.5122Z"
				fill="#F5F5F5"
			/>
			<path
				d="M295.303 75.0713L295.691 76.5202V76.5202L295.303 75.0713ZM303.459 75.5122L302.915 76.9103C302.925 76.9141 302.935 76.9178 302.945 76.9214L303.459 75.5122ZM239.335 90.0678L238.947 88.6189C238.147 88.8333 237.672 89.6558 237.886 90.456L239.335 90.0678ZM242.559 102.099L241.11 102.487L242.559 102.099ZM259.501 111.881L259.113 110.432L259.501 111.881ZM278.699 106.737L280.12 107.217C280.297 106.693 280.171 106.114 279.793 105.71C279.415 105.307 278.845 105.145 278.311 105.288L278.699 106.737ZM269.995 132.511L268.574 132.031C268.309 132.816 268.73 133.667 269.515 133.932L269.995 132.511ZM294.902 140.922L294.422 142.343C294.799 142.471 295.211 142.443 295.568 142.267C295.924 142.09 296.196 141.779 296.323 141.402L294.902 140.922ZM311.401 92.0642L312.823 92.5441L311.401 92.0642ZM295.691 76.5202C298.178 75.8538 300.688 76.0444 302.915 76.9103L304.002 74.1142C301.201 73.0249 298.038 72.7854 294.914 73.6224L295.691 76.5202ZM239.723 91.5166L295.691 76.5202L294.914 73.6224L238.947 88.6189L239.723 91.5166ZM244.008 101.711L240.784 89.6795L237.886 90.456L241.11 102.487L244.008 101.711ZM259.113 110.432C252.533 112.195 245.771 108.29 244.008 101.711L241.11 102.487C243.302 110.667 251.71 115.521 259.889 113.33L259.113 110.432ZM278.311 105.288L259.113 110.432L259.889 113.33L279.087 108.186L278.311 105.288ZM271.416 132.991L280.12 107.217L277.278 106.257L268.574 132.031L271.416 132.991ZM295.382 139.501L270.475 131.09L269.515 133.932L294.422 142.343L295.382 139.501ZM309.98 91.5843L293.481 140.442L296.323 141.402L312.823 92.5441L309.98 91.5843ZM302.945 76.9214C308.863 79.0805 312.007 85.5822 309.98 91.5843L312.823 92.5441C315.372 84.9952 311.417 76.819 303.973 74.1031L302.945 76.9214Z"
				fill="#2A2D33"
			/>
			<rect
				x="271.939"
				y="133.164"
				width="22.1871"
				height="5.65147"
				transform="rotate(18.6597 271.939 133.164)"
				fill="#F5F5F5"
				stroke="#2A2D33"
				strokeWidth="3"
				strokeLinejoin="round"
			/>
			<path
				d="M266.209 150.132L297.144 160.579L298.412 156.686L291.151 145.617L270.131 138.519L266.209 150.132Z"
				fill="#F5F5F5"
				stroke="#2A2D33"
				strokeWidth="3"
				strokeLinejoin="round"
			/>
			<path
				d="M270.067 132.381L280.759 100.66"
				stroke="#2A2D33"
				strokeWidth="3"
				strokeLinecap="round"
			/>
			<circle
				cx="310.947"
				cy="82.198"
				r="4.17897"
				fill="#F5F5F5"
				stroke="#2A2D33"
				strokeWidth="3"
			/>
			<path
				d="M270.198 32.4948L294.554 61.2859L285.908 68.3572L256.203 40.3743C254.017 38.3142 254.653 34.6886 257.411 33.4965L263.41 30.9031C265.776 29.8802 268.533 30.5267 270.198 32.4948Z"
				fill="#F5F5F5"
				stroke="#2A2D33"
				strokeWidth="3"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M286.572 36.8923C285.697 31.5367 289.329 26.4857 294.685 25.6106C298.688 24.9564 302.521 26.8206 304.567 30.0405H306.303L309.881 42.1463C310.188 43.186 309.847 44.3089 309.012 45.0016L307.951 45.8831C308.698 51.1595 305.091 56.0896 299.806 56.9532C297.677 57.3012 295.595 56.9365 293.805 56.034L289.595 58.4388L279.036 49.0231L287.75 44.102L286.572 36.8923Z"
				fill="#F5F5F5"
			/>
			<path
				d="M294.685 25.6106L294.443 24.1302L294.685 25.6106ZM286.572 36.8923L285.092 37.1342L286.572 36.8923ZM304.567 30.0405L303.301 30.845C303.576 31.2781 304.054 31.5405 304.567 31.5405V30.0405ZM306.303 30.0405L307.741 29.6153C307.553 28.9779 306.968 28.5405 306.303 28.5405V30.0405ZM309.881 42.1463L308.442 42.5714V42.5714L309.881 42.1463ZM309.012 45.0016L309.971 46.1556H309.971L309.012 45.0016ZM307.951 45.8831L306.993 44.7291C306.592 45.0616 306.393 45.578 306.466 46.0933L307.951 45.8831ZM299.806 56.9532L299.564 55.4728L299.806 56.9532ZM293.805 56.034L294.48 54.6946C294.031 54.468 293.498 54.4819 293.061 54.7315L293.805 56.034ZM289.595 58.4388L288.596 59.5583C289.077 59.9874 289.779 60.0611 290.339 59.7413L289.595 58.4388ZM279.036 49.0231L278.299 47.717C277.877 47.9549 277.596 48.3816 277.545 48.8628C277.493 49.3439 277.677 49.8205 278.038 50.1426L279.036 49.0231ZM287.75 44.102L288.488 45.4082C289.035 45.0989 289.332 44.4808 289.231 43.8601L287.75 44.102ZM294.443 24.1302C288.27 25.139 284.083 30.961 285.092 37.1342L288.052 36.6504C287.311 32.1124 290.389 27.8325 294.926 27.0909L294.443 24.1302ZM305.833 29.236C303.476 25.5273 299.059 23.3758 294.443 24.1302L294.926 27.0909C298.316 26.537 301.565 28.1138 303.301 30.845L305.833 29.236ZM306.303 28.5405H304.567V31.5405H306.303V28.5405ZM311.319 41.7211L307.741 29.6153L304.864 30.4656L308.442 42.5714L311.319 41.7211ZM309.971 46.1556C311.266 45.0798 311.796 43.3359 311.319 41.7211L308.442 42.5714C308.58 43.0361 308.427 43.538 308.054 43.8477L309.971 46.1556ZM308.909 47.037L309.971 46.1556L308.054 43.8477L306.993 44.7291L308.909 47.037ZM300.048 58.4336C306.14 57.4381 310.297 51.7554 309.436 45.6728L306.466 46.0933C307.099 50.5635 304.042 54.7411 299.564 55.4728L300.048 58.4336ZM293.13 57.3734C295.193 58.4138 297.595 58.8344 300.048 58.4336L299.564 55.4728C297.758 55.768 295.997 55.4591 294.48 54.6946L293.13 57.3734ZM293.061 54.7315L288.851 57.1363L290.339 59.7413L294.549 57.3365L293.061 54.7315ZM290.593 57.3193L280.034 47.9036L278.038 50.1426L288.596 59.5583L290.593 57.3193ZM279.774 50.3292L288.488 45.4082L287.013 42.7959L278.299 47.717L279.774 50.3292ZM285.092 37.1342L286.27 44.344L289.231 43.8601L288.052 36.6504L285.092 37.1342Z"
				fill="#2A2D33"
			/>
			<path
				d="M310.453 34.0431H299.674L301.152 46.131C301.479 48.799 299.878 51.4633 297.19 51.4633C289.593 51.4633 283.434 45.3042 283.434 37.707C283.434 30.1098 289.593 23.9507 297.19 23.9507C303.519 23.9507 308.85 28.2243 310.453 34.0431Z"
				fill="#F5F5F5"
				stroke="#2A2D33"
				strokeWidth="3"
				strokeLinejoin="round"
			/>
			<path
				d="M304.938 39.1001V41.9968"
				stroke="#2A2D33"
				strokeWidth="3"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M293.519 43.6007C292.915 43.8507 292.251 43.9161 291.61 43.7887C290.969 43.6612 290.381 43.3466 289.919 42.8846C289.457 42.4226 289.142 41.8341 289.015 41.1933C288.887 40.5525 288.953 39.8883 289.203 39.2847C289.453 38.6811 289.876 38.1652 290.419 37.8022"
				stroke="#2A2D33"
				strokeWidth="3"
				strokeLinecap="round"
			/>
			<path
				d="M267.109 38.3892L293.19 61.6418"
				stroke="#2A2D33"
				strokeWidth="3"
				strokeLinecap="round"
			/>
			<rect
				x="310.454"
				y="65.771"
				width="12.5149"
				height="12.5149"
				rx="4.17897"
				transform="rotate(45 310.454 65.771)"
				fill="#F5F5F5"
				stroke="#2A2D33"
				strokeWidth="3"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M266.291 93.5993C261.883 91.9915 259.541 87.15 261.051 82.6802L269.161 58.6649C270.693 54.1276 275.613 51.6916 280.151 53.2238C284.688 54.756 287.124 59.6763 285.592 64.2135L282.624 73.0013L304.104 67.2458L308.592 83.9973L271.671 93.8902C269.821 94.386 267.95 94.2442 266.291 93.5993Z"
				fill="#F5F5F5"
			/>
			<path
				d="M266.291 93.5993L266.835 92.2013C266.825 92.1975 266.815 92.1938 266.805 92.1901L266.291 93.5993ZM261.051 82.6802L262.472 83.1601L261.051 82.6802ZM269.161 58.6649L267.74 58.1849L269.161 58.6649ZM280.151 53.2238L280.63 51.8026L280.151 53.2238ZM285.592 64.2135L287.013 64.6934L285.592 64.2135ZM282.624 73.0013L281.203 72.5213C281.026 73.0453 281.152 73.6241 281.53 74.0275C281.908 74.4309 282.478 74.5933 283.012 74.4501L282.624 73.0013ZM304.104 67.2458L305.552 66.8576C305.338 66.0574 304.516 65.5825 303.715 65.7969L304.104 67.2458ZM308.592 83.9973L308.98 85.4462C309.365 85.3432 309.692 85.0918 309.891 84.7473C310.09 84.4028 310.144 83.9933 310.041 83.6091L308.592 83.9973ZM271.671 93.8902L272.06 95.3391L272.06 95.3391L271.671 93.8902ZM266.805 92.1901C263.16 90.8607 261.224 86.8565 262.472 83.1601L259.63 82.2002C257.859 87.4434 260.606 93.1223 265.777 95.0085L266.805 92.1901ZM262.472 83.1601L270.582 59.1448L267.74 58.1849L259.63 82.2002L262.472 83.1601ZM270.582 59.1448C271.849 55.3924 275.918 53.3778 279.671 54.6449L280.63 51.8026C275.308 50.0054 269.537 52.8628 267.74 58.1849L270.582 59.1448ZM279.671 54.6449C283.423 55.9121 285.438 59.9812 284.17 63.7336L287.013 64.6934C288.81 59.3713 285.953 53.5999 280.63 51.8026L279.671 54.6449ZM284.17 63.7336L281.203 72.5213L284.045 73.4812L287.013 64.6934L284.17 63.7336ZM283.012 74.4501L304.492 68.6947L303.715 65.7969L282.236 71.5524L283.012 74.4501ZM302.655 67.6341L307.143 84.3855L310.041 83.6091L305.552 66.8576L302.655 67.6341ZM308.204 82.5484L271.283 92.4413L272.06 95.3391L308.98 85.4462L308.204 82.5484ZM271.283 92.4413C269.751 92.8518 268.206 92.7345 266.835 92.2013L265.747 94.9974C267.693 95.7539 269.891 95.9202 272.06 95.3391L271.283 92.4413Z"
				fill="#2A2D33"
			/>
			<path
				d="M304.061 67.271L276.512 74.6201"
				stroke="#2A2D33"
				strokeWidth="3"
				strokeLinecap="round"
			/>
			<circle
				cx="310.946"
				cy="82.1983"
				r="4.94878"
				fill="#F5F5F5"
				stroke="#2A2D33"
				strokeWidth="3"
			/>
		</g>

		<g className={styles.animatedCourier__cloud}>
			<path
				d="M532 22.4538H525.411C525.029 22.4538 524.727 22.1329 524.715 21.7513C524.667 20.3227 524.251 18.7726 523.442 17.2951C521.37 13.5101 517.51 11.6352 514.82 13.1075C514.441 13.3153 514.105 13.5788 513.813 13.8886C513.464 14.2597 512.813 14.2744 512.528 13.8524C508.873 8.45176 504.052 5.49814 501.092 7.11823C500.927 7.2087 500.77 7.31174 500.623 7.42671C500.283 7.69124 499.771 7.68793 499.495 7.35803C495.564 2.66606 490.014 0.685097 485.936 2.91679C482.79 4.63871 481.283 8.45081 481.601 12.7852C481.642 13.3369 481.043 13.7593 480.523 13.5707C478.834 12.9581 477.121 12.9754 475.678 13.7651C473.263 15.087 472.263 18.2126 472.857 21.6209C472.931 22.047 472.614 22.4538 472.182 22.4538H454"
				stroke="#2A2D33"
				strokeWidth="3"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>

		<g className="line">
			<path
				d="M2 192H552"
				stroke="#2A2D33"
				strokeWidth="3"
				strokeLinecap="round"
			/>
		</g>
	</svg>
)

export default PhoneIcon
